export const print = "zRa";
export default {print};